import styled, { css } from 'styled-components';
import { media } from 'app/styles/variables';
import { generateFontSizing } from 'app/styles/mixins';
import { StyledUlWrapperSt } from 'app/shared/components/ModelReview/ModelReview.css';

export const RatingSt = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  margin-left: -1rem;
  width: calc(100% + 2rem);

  ${media.sm(css`
    margin-left: 0;
    width: auto;
  `)}
`;

export const RatingHeaderSt = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2.5rem;
  background: ${({ theme }) => theme.colors.neutral50};

  ${media.sm(css`
    flex-direction: row;
  `)};
`;

export const DescriptionSt = styled.div`
  ${media.sm(css`
    margin-left: 3.125rem;
  `)};
`;

export const RatingTitleSt = styled.div`
  margin-bottom: 0.5rem;
  color: ${({ theme }) => theme.colors.neutral800};
  text-align: center;

  ${media.sm(css`
    text-align: left;
  `)}
`;

export const SummarySt = styled.div`
  ${generateFontSizing('h2')};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  text-align: center;

  ${media.sm(css`
    text-align: left;
  `)}
`;

export const RatingBodySt = styled.div`
  display: flex;
  flex-direction: column;

  border: 1px solid ${({ theme }) => theme.colors.neutral50};
  border-top: none;

  ${media.md(css`
    flex-direction: row;
  `)};
`;

export const BulletsSt = styled.div`
  flex: 1;
  padding: 1.5rem 2.5rem 1rem 2.5rem;

  &:first-child {
    border-bottom: 1px solid ${({ theme }) => theme.colors.neutral50};

    ${media.md(css`
      border-bottom: none;
      border-right: 1px solid ${({ theme }) => theme.colors.neutral50};
    `)};
  }
`;

export const BulletTitleSt = styled.div`
  flex: 1;
  margin-bottom: 1.5rem;
  font-size: ${({ theme }) => theme.fontSizes.p};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  line-height: 2rem;
  color: ${({ theme }) => theme.colors.neutral800};
`;

const BulletsContentWrapperSt = styled(StyledUlWrapperSt)`
  ${media.sm(css`
    width: calc(100% - 4rem);
  `)};
`;

export const ProsBulletsWrapperSt = styled(BulletsContentWrapperSt).attrs({
  icon: '/assets/icons/icon-circle-plus.svg',
})``;

export const ConsBulletsWrapperSt = styled(BulletsContentWrapperSt).attrs({
  icon: '/assets/icons/icon-circle-minus.svg',
})``;
